export default function TermsOfService({ onBack }) {
  return (
    <div style={s.wrap}>
      <div style={s.container}>
        <button style={s.backBtn} onClick={onBack}>← Back</button>

        <h1 style={s.title}>Terms of Service</h1>
        <p style={s.updated}>Last updated: {new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}</p>

        <Section title="The Service">
          <p style={s.p}>
            RBXWar ("we", "us", "our") provides software that automates pricing decisions for
            Roblox limited items on your behalf, based on settings you configure. By purchasing
            a key or using the dashboard, you agree to these terms.
          </p>
        </Section>

        <Section title="Roblox's Terms of Service">
          <p style={s.p}>
            RBXWar interacts with Roblox on your behalf using your account credentials. Automating
            actions on Roblox may fall outside Roblox's own Terms of Service, and Roblox may take
            action against accounts it determines are being used in violation of its rules,
            including warnings, trading restrictions, or account termination. <b style={{color:"#f59e0b"}}>
            You use RBXWar entirely at your own risk with respect to your Roblox account's standing.</b>{" "}
            We are not affiliated with, endorsed by, or responsible to Roblox Corporation, and we
            cannot prevent or reverse any action Roblox takes against your account.
          </p>
        </Section>

        <Section title="Subscriptions & Billing">
          <p style={s.p}>
            Plans are billed monthly (or as a one-time lifetime purchase, where offered) through
            our third-party payment processor. Monthly subscriptions renew automatically until
            cancelled. You can cancel anytime. Cancelling stops future renewals but does not
            retroactively refund the current billing period.
          </p>
        </Section>

        <Section title="Refunds">
          <p style={s.p}>
            Because access is granted immediately upon activation, all sales are final and
            non-refundable except where required by law. If something's genuinely broken on our
            end and you never got working access, reach out on Discord. We handle those
            case-by-case.
          </p>
        </Section>

        <Section title="Account Access & Recovery">
          <p style={s.p}>
            Each account gets a one-time recovery phrase when first activated, shown only once.
            It's your responsibility to save it. We cannot restore access to an account if both
            the license key and the recovery phrase are lost. We have no way to verify ownership
            beyond these two credentials.
          </p>
        </Section>

        <Section title="Acceptable Use">
          <p style={s.p}>
            You agree not to attempt to abuse, reverse-engineer, resell access to, or interfere
            with the normal operation of the service. We reserve the right to suspend or terminate
            access, without refund, for accounts found abusing the service, sharing keys, or using
            the platform for purposes outside its intended function.
          </p>
        </Section>

        <Section title="No Warranty">
          <p style={s.p}>
            RBXWar is provided "as is." We don't guarantee any specific pricing outcome, sale
            volume, or uptime figure. Roblox's own APIs, marketplace behavior, and policies are
            outside our control and can change at any time in ways that affect how the service
            performs.
          </p>
        </Section>

        <Section title="Limitation of Liability">
          <p style={s.p}>
            To the fullest extent permitted by law, RBXWar is not liable for indirect, incidental,
            or consequential damages arising from use of the service, including lost items, lost
            Robux, or Roblox account actions taken against you. Our total liability for any claim
            is limited to the amount you paid us in the 30 days prior to the claim.
          </p>
        </Section>

        <Section title="Changes to These Terms">
          <p style={s.p}>
            We may update these terms as the service evolves. Continued use after a change means
            you accept the updated terms. Material changes will be reflected by updating the date
            at the top of this page.
          </p>
        </Section>

        <Section title="Contact">
          <p style={s.p}>
            Questions about these terms? Our{" "}
            <a href="https://discord.gg/683FrRFgsK" target="_blank" rel="noopener noreferrer" style={s.link}>Discord server</a>{" "}
            is the only place we offer support. Join and open a ticket there.
          </p>
        </Section>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div style={s.section}>
      <h2 style={s.h2}>{title}</h2>
      {children}
    </div>
  );
}

const s = {
  wrap:      { minHeight: "calc(100vh / var(--ui-zoom, 1))", background: "#080808", color: "#fff", fontFamily: "'Rubik','Inter',sans-serif", padding: "48px 24px" },
  container: { maxWidth: 720, margin: "0 auto" },
  backBtn:   { background: "none", border: "1px solid #222", color: "#888", borderRadius: 8, padding: "8px 16px", fontSize: 13, cursor: "pointer", marginBottom: 32, fontFamily: "inherit" },
  title:     { fontSize: 36, fontWeight: 800, margin: "0 0 8px", fontFamily: "'Khaviax', sans-serif" },
  updated:   { color: "#555", fontSize: 13, marginBottom: 40 },
  section:   { marginBottom: 32 },
  h2:        { fontSize: 18, fontWeight: 700, color: "var(--rbx-accent, #38bdf8)", marginBottom: 12, fontFamily: "'Moderniz', sans-serif" },
  p:         { color: "#aaa", fontSize: 14.5, lineHeight: 1.75, margin: "0 0 12px" },
  link:      { color: "var(--rbx-accent, #38bdf8)", textDecoration: "none" },
};
